import { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  setOrganizationCreated,
  getcountry,
  getcity,
  categorylist,
  createorg,
} from "../../../store/Organization/organizationSlice";
import { pincodes_by_state } from "../../../store/User/ProfileSlice";
import { updatenotificationdata } from '../../../store/Admin/Common/CommonSlice'
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PhoneNumberField from "../../../components/common/PhoneNumberField";
import { isValidPhoneNumber } from "react-phone-number-input";
// The contact number is stored without its country code (contact_number) and
// the dial code alongside it (contact_country_code); toE164 recombines them
// for PhoneNumberField, splitPhone splits them again on save.
import { splitPhone, toE164 } from "../../../utils/phone";

// const validationSchema = Yup.object().shape({
//   pan: Yup.string()
//     .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number")
//     .required("PAN is required"),
//   gst: Yup.string()
//     .matches(
//       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//       "Invalid GST number"
//     )
//     .required("GST is required"),
//   country: Yup.string().required("Country is required"),
//   city: Yup.string().required("City is required"),
//   address1: Yup.string().required("Address is required"),
//   address2: Yup.string(),
//   contact_number: Yup.string()
//     .matches(/^\+?[1-9][0-9]{7,14}$/, "Invalid phone number") .matches(/^\d{10}$/, "Invalid phone number")
//     .required("Contact number is required"),
//   contact_person: Yup.string().required("Contact person name is required"),
//   category: Yup.string().required("Category is required"),
// });
const panValidation = Yup.string()
  .trim()
  .uppercase()
  .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number (format: ABCDE1234F)")
  .required("PAN is required");

const validationSchemagst = Yup.object().shape({
  pan: panValidation,
  gst: Yup.string()
    .trim()
    .uppercase()
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GST number"
    )
    .test("pan-match", "PAN inside GST must match the entered PAN", function (value) {
      const { pan } = this.parent;
      if (!value || !pan) return true;
      return value.substring(2, 12) === pan.toUpperCase().trim();
    })
    .required("GST is required"),
  country: Yup.string().required("Country is required"),
  city: Yup.string().required("City is required"),
  address1: Yup.string().trim().required("Address is required"),
  address2: Yup.string(),
  contact_number: Yup.string()
    .required("Contact number is required")
    .test("valid-phone", "Invalid contact number", (value) =>
      value ? isValidPhoneNumber(value) : false
    ),
  contact_person: Yup.string().trim().required("Contact person name is required"),
  category: Yup.string().required("Category is required"),
});

const validationSchemaadhaar = Yup.object().shape({
  pan: panValidation,
  adhaar: Yup.string().trim().required("Aadhaar no is required"),
  country: Yup.string().required("Country is required"),
  city: Yup.string().required("City is required"),
  address1: Yup.string().trim().required("Address is required"),
  address2: Yup.string(),
  contact_number: Yup.string()
    .required("Contact number is required")
    .test("valid-phone", "Invalid contact number", (value) =>
      value ? isValidPhoneNumber(value) : false
    ),
  contact_person: Yup.string().trim().required("Contact person name is required"),
  category: Yup.string().required("Category is required"),
});

export default function Organizationcreate(props) {
  const [country, setCountry] = useState([]);
  const [city, setCity] = useState([]);
  const [category, setCategory] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [kyc,setkyc]=useState("false")
  const formikRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOrganizationCreated = useSelector((state) => state?.organization?.isOrganizationCreated);
  console.log(isOrganizationCreated,"orgcreated ");

  const gstDetails = props?.instance?.gstdetails;
  const adhaarDetails = props?.instance?.adhaarno?props?.instance?.adhaarno:props?.instance?.adhaar;
console.log(adhaarDetails,"adhaardetails");
  // The user's own address fields (address, addresslane, pincode, state, city) are
  // preferred over the GST/Aadhaar-derived address. Their location depends on the flow:
  //  - User Management ("user"): top-level on the instance.
  //  - KYC Verification ("kyc"): nested under user_details (object or array).
  const userDetails = Array.isArray(props?.instance?.user_details)
    ? props.instance.user_details[0]
    : props?.instance?.user_details;
  const addrSource =
    props?.instance?.type === "user"
      ? props?.instance
      : props?.instance?.type === "kyc"
      ? userDetails
      : null;
  // The organization name. `company_name` is the single key every screen reads:
  // on a KYC row the backend has already resolved it (organization -> user ->
  // the KYC row's own snapshot, see utils/orgName.js), and on a user row it is
  // the user's own value, which that same rule treats as the truth until an
  // organization exists. `user_details` stays as a fallback for rows served
  // before the resolution existed.
  const orgName =
    props?.instance?.company_name || userDetails?.company_name || "";

  // The Aadhaar number. `adhaarDetails` above is Cashfree's identity payload
  // (name, dob, split_address) and contains no number, which is why this field
  // used to render empty.
  //
  // /kyc_verification_list resolves the number into a single `adhaar_number`
  // key, already preferring the full twelve digits over the masked form, so the
  // KYC flow needs nothing but the first line. The rest cover the User
  // Management flow, where the instance is the user document itself, and rows
  // that predate the field on either side.
  const adhaarNumber =
    props?.instance?.adhaar_number ||
    userDetails?.adhaar_number ||
    props?.instance?.reg_data?.request?.doc_number_full ||
    props?.instance?.reg_data?.request?.doc_number ||
    props?.instance?.reg_data?.request?.doc_number2 ||
    "";
  // Only prefer these when we actually have some address data to show.
  const useUserAddr =
    !!addrSource &&
    (addrSource.address ||
      addrSource.addresslane ||
      addrSource.pincode ||
      addrSource.city ||
      addrSource.state);
  const extractPanFromGst = (gstin) => {
    if (!gstin || gstin.length < 12) return "";
    const pan = gstin.substring(2, 12).toUpperCase();
    return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan) ? pan : "";
  };

  // GST address builders
  const buildGstAddress1 = (splitAddr, fullAddr) => {
    if (splitAddr) {
      const parts = [splitAddr.building_number, splitAddr.building_name, splitAddr.location]
        .filter((v) => v?.trim());
      if (parts.length) return parts.join(", ");
    }
    return fullAddr?.trim() || "";
  };

  const buildGstAddress2 = (splitAddr) => {
    if (!splitAddr) return "";
    return [splitAddr.street, splitAddr.district].filter((v) => v?.trim()).join(", ");
  };

  // Aadhaar address builders
  const buildAdhaarAddress1 = (splitAddr, fullAddr) => {
    if (splitAddr) {
      const parts = [splitAddr.house, splitAddr.street, splitAddr.locality]
        .filter((v) => v?.trim());
      if (parts.length) return parts.join(", ");
    }
    return fullAddr?.trim() || "";
  };

  const buildAdhaarAddress2 = (splitAddr) => {
    if (!splitAddr) return "";
    return [splitAddr.vtc, splitAddr.dist].filter((v) => v?.trim()).join(", ");
  };

  const findCityMatch = (cities, ...candidates) => {
    for (const candidate of candidates) {
      if (!candidate?.trim()) continue;
      const val = candidate.toLowerCase().trim();
      const exact = cities.find((c) => c.cityName?.toLowerCase() === val);
      if (exact) return exact;
      const partial = cities.find((c) => c.cityName?.toLowerCase().includes(val));
      if (partial) return partial;
    }
    return null;
  };

  // Resolve the pincode's city area via /pincodes_by_state and select the matching
  // option in the (already-loaded) city dropdown. The dropdown value is a city _id,
  // so the API's cityArea is matched against the loaded city names.
  const selectCityFromPincode = (pincode, cities, setFieldValue) => {
    if (!/^\d{6}$/.test(String(pincode || "")) || !cities?.length) return;
    dispatch(pincodes_by_state(pincode)).then((res) => {
      const cityArea = res?.payload?.data?.data?.[0]?.cityArea;
      if (!cityArea) return;
      const match = findCityMatch(cities, cityArea);
      if (match) setFieldValue("city", match._id);
    });
  };

  useEffect(() => {
    dispatch(getcountry())
      .then((res) => {
        setCountry(res?.payload?.data);
      })
      .catch((err) => {
        console.error(err);
      });
    dispatch(categorylist())
      .then((res) => {
        setCategory(res?.payload?.data);
      })
      .catch((err) => {
        console.error(err);
      });
      setkyc(props?.instance?.kyc)
  }, [dispatch]);

  const applyCountry = (countryId, setFieldValue, onCitiesLoaded) => {
    setSelectedCountryId(countryId);
    setFieldValue("country", countryId);
    setFieldValue("city", "");

    dispatch(getcity(countryId))
      .then((res) => {
        const cities = res?.payload?.data || [];
        setCity(cities);
        setSelectedCountryId(countryId);
        if (onCitiesLoaded) onCitiesLoaded(cities);
      })
      .catch(console.error);
  };

  // Auto-populate country and city from gstdetails or adhaardetails once country list is loaded
  useEffect(() => {
    if (!country?.length || !formikRef.current) return;

    const { setFieldValue } = formikRef.current;

    // User/KYC flow: resolve Country/City from the user's own fields first.
    if (useUserAddr && (addrSource?.city || addrSource?.pincode || addrSource?.state)) {
      const india = country.find((c) => c.name?.toLowerCase() === "india");
      if (!india) return;
      applyCountry(india._id, setFieldValue, (cities) => {
        const match = findCityMatch(cities, addrSource?.city, addrSource?.state);
        if (match && formikRef.current) formikRef.current.setFieldValue("city", match._id);
        // Prefer the pincode-API city when it maps to a dropdown option.
        selectCityFromPincode(addrSource?.pincode, cities, formikRef.current.setFieldValue);
      });
      return;
    }

    if (!gstDetails && !adhaarDetails) return;

    if (adhaarDetails) {
      const countryName = adhaarDetails.split_address?.country?.toLowerCase().trim() || "india";
      const matched = country.find((c) => c.name?.toLowerCase() === countryName)
        || country.find((c) => c.name?.toLowerCase() === "india");
      if (!matched) return;

      applyCountry(matched._id, setFieldValue, (cities) => {
        const s = adhaarDetails.split_address;
        const city = findCityMatch(cities, s?.state, s?.dist, s?.vtc);
        if (city && formikRef.current) formikRef.current.setFieldValue("city", city._id);
        // Prefer the pincode-API city when it maps to a dropdown option.
        selectCityFromPincode(s?.pincode, cities, formikRef.current.setFieldValue);
      });
    } else if (gstDetails) {
      const indiaCountry = country.find((c) => c.name?.toLowerCase() === "india");
      if (!indiaCountry) return;

      applyCountry(indiaCountry._id, setFieldValue, (cities) => {
        const s = gstDetails.principal_place_split_address;
        const city = findCityMatch(cities, s?.city, s?.state, s?.district);
        if (city && formikRef.current) formikRef.current.setFieldValue("city", city._id);
        // Prefer the pincode-API city when it maps to a dropdown option.
        selectCityFromPincode(s?.pincode, cities, formikRef.current.setFieldValue);
      });
    }
  }, [country, gstDetails, adhaarDetails]);

console.log(props)
console.log(props?.instance?.kam_user,"HI");
  const initialValues = {
    // `company_name` on every path, which is the same key the Profile section
    // shows under "Organization Name" — the two screens sit side by side and
    // must never disagree.
    //
    // This used to read `full_name` on the Aadhaar path, on the assumption that
    // an Aadhaar signup has no company name. It does: registrationAccountService
    // already stores `company_name = request.full_name` when the account is
    // created, so the fallback was covering a case the backend had handled, and
    // its only real effect was to show the person's own name here (and to keep
    // showing the registration-time name after an admin edited the profile)
    // while Profile showed the company. `full_name` is the individual, and this
    // screen already displays it separately as "User Name".
    org_name: orgName,
    pan: gstDetails ? extractPanFromGst(gstDetails.GSTIN) : "",
    gst: gstDetails ? gstDetails.GSTIN : "",
    adhaar: adhaarDetails ? adhaarNumber : "",
    country: "",
    city: "",
    // User/KYC flow: "Address Lane" <- addresslane, "Address Lane 2" <- address.
    address1: useUserAddr && addrSource?.addresslane
      ? addrSource.addresslane
      : adhaarDetails
      ? buildAdhaarAddress1(adhaarDetails.split_address, adhaarDetails.address)
      : gstDetails
      ? buildGstAddress1(gstDetails.principal_place_split_address, gstDetails.principal_place_address)
      : "",
    address2: useUserAddr && addrSource?.address
      ? addrSource.address
      : adhaarDetails
      ? buildAdhaarAddress2(adhaarDetails.split_address)
      : gstDetails
      ? buildGstAddress2(gstDetails.principal_place_split_address)
      : "",
    contact_number: props?.instance?.kyc_user?.phone_number
      ? toE164(props.instance.kyc_user.phone_number, props?.instance?.kyc_user?.country_code)
      : toE164(props?.instance?.phone_number || "", props?.instance?.country_code),
    contact_person: adhaarDetails?.name || "",
    pincode: (useUserAddr && addrSource?.pincode)
      || adhaarDetails?.split_address?.pincode
      || gstDetails?.principal_place_split_address?.pincode
      || "",
    // New organizations default to category D.
    category: "D",
    user_id: props?.instance?.instance?._id,
    kam_id: props?.instance?.instance?.kyc_user?._id,
  };

  const handlecancel = () => {
    dispatch(setOrganizationCreated(false));
  };
  const handleCountryChange = (e, setFieldValue) => {
    const countryId = e.target.options[e.target.selectedIndex].getAttribute('data-id');
    applyCountry(countryId, setFieldValue);
  };
    
    
  const handleSubmit = (values, { setSubmitting }) => {
    console.log("click")
    console.log("Form submitted with values:", values);
    const parsedPhone = splitPhone(values.contact_number);
    const formattedValues = {
      // Same key the form was populated from, so what is submitted is what the
      // admin was shown.
      org_name: orgName,
      pan: values.pan,
      gst: values.gst || undefined,
      adhaar: values.adhaar || undefined,
      // Stored without the country code (e.g. "8287259604"), the dial code
      // travelling beside it in contact_country_code.
      contact_number: parsedPhone ? parsedPhone.nationalNumber : values.contact_number,
      contact_country_code: parsedPhone ? parsedPhone.countryCode : undefined,
      country_id: selectedCountryId,
      city_id: values.city,
      address1: values.address1,
      address2: values.address2,
      pincode: values.pincode,
      contact_person: values.contact_person,
      category: values.category,
      user_id:props?.instance?.type==="kyc"?props?.instance?.user_id:props?.instance?._id ,
      kam_id:props?.instance?.type==="kyc"?props?.instance?.kyc_user?.key_account_manager:props?.instance?.kam_user?._id,
    };

    console.log("Form submitted with values:", formattedValues);
    dispatch(createorg(formattedValues))
      .then((res) => {
        console.log("Organization created:", res);
        if(res.payload.statusCode===200){
          dispatch(setOrganizationCreated(false));
          dispatch(updatenotificationdata({ success: 'success', message: res?.payload?.message || 'Organization created successfully' }))
          navigate('/organization-management')
        } else {
          const errData = res?.payload;
          const errorMsg = Array.isArray(errData?.errors)
            ? errData.errors.map(e => e?.msg).join(', ')
            : Array.isArray(errData?.message)
            ? errData.message.map(e => (typeof e === 'string' ? e : e?.msg)).join(', ')
            : errData?.message || 'Something went wrong';
          dispatch(updatenotificationdata({ success: 'error', message: errorMsg }));
          setSubmitting(false);
        }
      })
      .catch((err) => {
        console.error("Error creating organization:", err);
        dispatch(updatenotificationdata({ success: 'error', message: err?.response?.data?.message || 'Something went wrong' }));
        setSubmitting(false);
      });
  };
const usevalidschema=adhaarDetails?validationSchemaadhaar:validationSchemagst
console.log(usevalidschema,"validschema")
  return (
    <div className="w-full max-w-4xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">
            Organization Details
          </h2>
        </div>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={usevalidschema}  //validationSchemagst validationSchemaadhaar
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <Form className="p-6">
              <div className="grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
                {/* Organization Name Field */}
                <div>
                  <label
                    htmlFor="org_name"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Organization Name
                  </label>
                  <Field
                    type="text"
                    name="org_name"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                    readOnly
                    value={values.org_name}
                  />
                </div>

                {/* PAN Field */}
                <div>
                  <label
                    htmlFor="pan"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    PAN <span className="text-red-500">*</span>
                  </label>
                  {/*
                    PAN is auto-derived from GST in the GST flow (read-only).
                    In the Aadhaar flow there is no PAN source, so let the user
                    type it in.
                  */}
                  <Field
                    type="text"
                    name="pan"
                    value={values.pan}
                    onChange={
                      adhaarDetails && !gstDetails
                        ? (e) =>
                            setFieldValue("pan", e.target.value.toUpperCase())
                        : undefined
                    }
                    className={
                      adhaarDetails && !gstDetails
                        ? "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        : "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                    }
                    placeholder="Enter PAN number (e.g. ABCDE1234F)"
                    maxLength={10}
                    readOnly={!(adhaarDetails && !gstDetails)}
                  />
                  <ErrorMessage
                    name="pan"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* GST Field — only when gst data is present */}
                {gstDetails && (
                  <div>
                    <label
                      htmlFor="gst"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      GST <span className="text-red-500">*</span>
                    </label>
                    <Field
                      type="text"
                      name="gst"
                      value={values.gst}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                      placeholder="Enter GST number"
                      readOnly
                    />
                    <ErrorMessage
                      name="gst"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                )}

                {/* Aadhaar Field — only when aadhaar data is present */}
                {adhaarDetails && (
                  <div>
                    <label
                      htmlFor="adhaar"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Aadhaar <span className="text-red-500">*</span>
                    </label>
                    <Field
                      type="text"
                      name="adhaar"
                      onChange={(e) => setFieldValue(e.target.name, e.target.value)}
                      value={values.adhaar}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Aadhaar reference"
                    />
                    <ErrorMessage
                      name="adhaar"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                )}

                {/* Country Field */}
                <div>
                  <label
                    htmlFor="country"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Country <span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="select"
                    name="country"
                    onChange={(e) => handleCountryChange(e, setFieldValue)}
                    value={values.country}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                    disabled
                  >
                    <option value="">Select a country</option>
                    {country?.map((item) => (
                      <option key={item._id} value={item._id} data-id={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="country"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* City Field */}
                <div>
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    City <span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="select"
                    name="city"
                    onChange={(e) => setFieldValue(e.target.name, e.target.value)}
                    value={values.city}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Select a city</option>
                    {city?.map((item) => (
                      <option key={item._id} value={item._id} data-id={item._id}>
                        {item.cityName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* Address 1 Field */}
                <div>
                  <label
                    htmlFor="address1"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Address Lane <span className="text-red-500">*</span>
                  </label>
                  <Field
                    type="text"
                    name="address1"
                    onChange={(e) => setFieldValue(e.target.name, e.target.value)}
                    value={values.address1}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter address line 1"
                  />
                  <ErrorMessage
                    name="address1"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* Address 2 Field */}
                <div>
                  <label
                    htmlFor="address2"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Address Lane 2
                  </label>
                  <Field
                    type="text"
                    name="address2"
                    onChange={(e) => setFieldValue(e.target.name, e.target.value)}
                    value={values.address2}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter address line 2"
                  />
                </div>
                <div>
                  <label htmlFor="pincode" className="block text-sm font-medium text-gray-700 mb-1">
                    Pincode
                  </label>
                  <Field
                    type="text"
                    name="pincode"
                    values={props.pincode}
                    onChange={(e) => {
                      setFieldValue(e.target.name, e.target.value);
                      selectCityFromPincode(e.target.value, city, setFieldValue);
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                    placeholder="Enter  pincode"
                    // readOnly={!isEditing}
                  />
                </div>
                {/* <div>
                  <label
                    htmlFor="contact_person"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    
                  </label>
                  <Field
                    type="text"
                    name="contact_person"
                    onChange={(e) => setFieldValue(e.target.name, e.target.value)}
                    value={values.contact_person}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter contact person name"
                  />
                  <ErrorMessage
                    name="contact_person"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div> */}

                {/* Contact Number Field */}
                <div>
                  <label
                    htmlFor="contact_number"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <Field
                    name="contact_number"
                    component={PhoneNumberField}
                    placeholder="Enter contact number"
                    lockCountry
                  />
                  <ErrorMessage
                    name="contact_number"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* Contact Person Field */}
                <div>
                  <label
                    htmlFor="contact_person"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Contact Person <span className="text-red-500">*</span>
                  </label>
                  <Field
                    type="text"
                    name="contact_person"
                    onChange={(e) => setFieldValue(e.target.name, e.target.value)}
                    value={values.contact_person}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter contact person name"
                  />
                  <ErrorMessage
                    name="contact_person"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>


                {/* Category Field */}
                <div>
                  <label
                    htmlFor="category"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Category <span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="select"
                    name="category"
                    onChange={(e) => {
                      if (e.target.name === 'country') {
                        handleCountryChange(e, setFieldValue);
                      } else {
                        setFieldValue(e.target.name, e.target.value);
                      }
                    }}
                    value={values.category}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {/* <option value="">Select a category</option> */}
                    {category?.map((item) => (
                      <option key={item._id} value={item.category_name}>
                        {item.category_name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="category"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>
              </div>

              {/* Submit and Cancel Buttons */}
              <div className="mt-6 flex justify-end space-x-4">
                <button
                  type="button"
                  onClick={handlecancel}
                  className="bg-black text-white py-1 px-5 rounded-md hover:bg-yellow-600 transition duration-300 ease-in-out"

                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-yellow-600 text-white py-1 px-5 rounded-md hover:bg-black transition duration-300 ease-in-out"
                >
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}